import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/design-system/table';
import { useDynamicLocale } from '@/hoslog-intl';
import { formatAmount } from '@/lib/format';
import { MonthlyReportData } from '@/services/payment/payment.types';

export const ApproveAllConfirmationDialog = ({ selectedData }: { selectedData: MonthlyReportData[] }) => {
  const { t } = useDynamicLocale();
  const tableHeaders = [
    { label: t('common.page.tableColumn.sn'), align: 'left' },
    { label: t('common.page.tableColumn.requestId'), align: 'left' },
    { label: t('common.page.tableColumn.affiliateInformation'), align: 'left' },
    { label: t('common.page.tableColumn.requestedAmount'), align: 'right' },
  ] as const;

  return (
    <div className="border border-muted rounded-xs my-5 mx-4">
      <Table>
        <TableHeader>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableHead
                key={header.label}
                className={`py-2.5 px-3 text-xs text-secondary ${header.align === 'right' ? 'text-right' : 'text-left'}`}
              >
                {header.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {selectedData.map((payment, i) => (
            <TableRow className="border-b border-muted" key={payment.id}>
              <TableCell className="text-xs">{i + 1}</TableCell>
              <TableCell className="text-xs">{payment.requestId}</TableCell>
              <TableCell className="text-xs">{payment.accountHolderName}</TableCell>
              <TableCell className="text-end">
                {formatAmount(payment.requestedAmount, '円', 'en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </TableCell>
            </TableRow>
          ))}
          <TableRow className="text-end">
            <TableCell colSpan={4} className="py-2.5 px-3 text-caption font-medium text-end">
              {t('common.page.table.total')}:{' '}
              {formatAmount(
                selectedData.reduce((sum, payment) => sum + payment.requestedAmount, 0),
                '円',
                'en-US',
                { minimumFractionDigits: 2, maximumFractionDigits: 2 },
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};
